import { IMonthsData } from "./CalendarioObblighi.types";

export const HEADERS = {
  0: "Codice Sel", 
  1: "Ambito Normativo",
  2: "Italiano",
  3: "Inglese",
  4: "Titolo Selection",
  5: "DESTINATARI",
  6: "Mese di Pubblicazione",
  7: "Decade",
  8: "PVR 2025"
};

export const HEADERS_LABEL = {
  CODE_SEL: "Codice Sel", 
  AMBITO: "Ambito Normativo",
  ITALIAN: "Italiano",
  ENGLISH: "Inglese",
  TITLE_SELECTION: "Titolo Selection",
  DESTINATARI: "DESTINATARI",
  MONTH: "Mese di Pubblicazione",
  DECADE: "Decade",
  PVR: "PVR 2025"
};


export const languagesString = (italian: string, english: string) => {
  if(italian === "X" && english === "X") return "Italiano, Inglese";
  if(italian === "X") return "Italiano";
  if(english === "X") return "Inglese";

  return "Nessuna lingua";

};

export const checkPvr = (pvr: string) => pvr === "SI";

export const monthOrder = [
  "GENNAIO", 
  "FEBBRAIO", 
  "MARZO", 
  "APRILE", 
  "MAGGIO", 
  "GIUGNO",
  "LUGLIO", 
  "AGOSTO", 
  "SETTEMBRE", 
  "OTTOBRE", 
  "NOVEMBRE", 
  "DICEMBRE"
];
export const monthIndex = {
  "Gennaio": 0,
  "Febbraio": 1,
  "Marzo": 2,
  "Aprile": 3,
  "Maggio": 4,
  "Giugno": 5,
  "Luglio": 6, 
  "Agosto": 7, 
  "Settembre": 8, 
  "Ottobre": 9, 
  "Novembre": 10, 
  "Dicembre": 11
};

export const sortByMonthOrder = (groupedByMonth: string[][]) => {

  // Funzione per il Capitalize (es: SETTEMBRE -> Settembre)
  const capitalize = (labelMonth:string) => labelMonth.charAt(0).toUpperCase() + labelMonth.slice(1).toLowerCase();

  // 1. Raggruppamento dei dati (saltando l'indice 0)
  const grouped = groupedByMonth.slice(1).reduce((acc, row) => {
    const meseChiave = row[6]; // "SETTEMBRE", "GENNAIO", ecc.
  
    if (!meseChiave) return acc; // Salto righe sporche o vuote

    const nuovoElemento = {
      "Codice Sel": row[0],
      "Ambito Normativo": row[1],
      "Italiano": row[2],
      "Inglese": row[3],
      "Titolo Selection": row[4],
      "DESTINATARI": row[5],
      "Mese di Pubblicazione": capitalize(meseChiave),
      "Decade": row[7],
      "PVR 2025": row[8]
    };

    //@ts-expect-error
    if (!acc[meseChiave]) {
      //@ts-expect-error
      acc[meseChiave] = {
        label: capitalize(meseChiave),
        data: []
      };
    }
    
    //@ts-expect-error
    acc[meseChiave].data.push(nuovoElemento);
    return acc;
  }, {});

  // 2. Trasformazione in array ordinato secondo il calendario
  const csvDataFormatted = monthOrder
  //@ts-expect-error
    .filter(mese => grouped[mese]) // Prende solo i mesi che hanno dati
  //@ts-expect-error
    .map(mese => grouped[mese]);
  return csvDataFormatted;
};

export const activeMonthData = (monthsData: IMonthsData[], active:string) => {
  let activeMonth: IMonthsData | null = null;
  activeMonth = monthsData.find(item => item.label === active) ?? null;

  return activeMonth?.data;
};
